import { render } from "./wokerDetail15.vue?vue&type=template&id=92870296&scoped=true"
import script from "./wokerDetail15.vue?vue&type=script&lang=js"
export * from "./wokerDetail15.vue?vue&type=script&lang=js"

import "./wokerDetail15.vue?vue&type=style&index=0&id=92870296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92870296"]])

export default __exports__